import { useResourceListQuery } from 'src/api';

import { useResourcesUserRoleCategory } from './useResourcesUserRoleCategory';

export const useResourceList = (skip?: boolean) => {
  const { userRoleCategory } = useResourcesUserRoleCategory();

  const { data, loading } = useResourceListQuery({
    skip: !userRoleCategory || skip,
    variables: {
      filter: {
        userRoleCategory: { has: userRoleCategory },
      },
    },
  });

  return {
    resourcesList: data?.resourceList ?? [],
    resourcesCount: data?.resourceCount || 0,
    loading,
  };
};
